import WebFont from 'webfontloader';

const webfontloader = (opts) => {
  return WebFont.load(opts);
};

export default (ctx, inject) => {
  inject('webfontloader', webfontloader);
};
